import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WechatWorkOutlinedSvg from "@ant-design/icons-svg/es/asn/WechatWorkOutlined";
import AntdIcon from "../components/AntdIcon";
var WechatWorkOutlined = function WechatWorkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WechatWorkOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WechatWorkOutlined.displayName = 'WechatWorkOutlined';
}
export default /*#__PURE__*/React.forwardRef(WechatWorkOutlined);